import { baseFetch } from "./base";
import type { HcpSearchResult } from "../types/hcpMention";
import { rememberHcpSearchLabels } from "../utils/hcpMentions";

function asRecord(value: unknown): Record<string, unknown> | null {
  return value !== null && typeof value === "object"
    ? (value as Record<string, unknown>)
    : null;
}

function asString(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

function asNumber(value: unknown, fallback: number): number {
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : fallback;
}

function normalizeHcpSearchResult(item: unknown): HcpSearchResult | null {
  const row = asRecord(item);
  if (!row) return null;

  const mentionToken = asString(row.mentionToken);
  const label = asString(row.label);
  if (!mentionToken || !label) return null;

  return {
    mentionToken,
    label,
    detail: asString(row.detail) || undefined,
    ownerName: asString(row.ownerName) || undefined,
    duplicateAssignment: Boolean(row.duplicateAssignment),
    duplicateAssignmentCount: asNumber(row.duplicateAssignmentCount, 1),
  };
}

export const searchHcps = async (text: string): Promise<HcpSearchResult[]> => {
  const response = await baseFetch.get<{ results?: unknown[] }>(
    "/integration/search",
    { params: { text } },
  );
  const rawResults = Array.isArray(response.data?.results)
    ? response.data.results
    : [];

  const results = rawResults
    .map(normalizeHcpSearchResult)
    .filter((row): row is HcpSearchResult => row !== null);
  rememberHcpSearchLabels(results);
  return results;
};
